import { render, staticRenderFns } from "./_level.vue?vue&type=template&id=11bc6940"
import script from "./_level.vue?vue&type=script&lang=js"
export * from "./_level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports